export interface BlobUploadResponse {
  fileUrl: string;
  fileName: string;  
  fileSize: number;
  fileType: string;
  fileDuration: string;
  stage: "select" | "upload" | "soft-delete" | "exist-delete";
  status: boolean;
  preSignedUrl?: string;
}

export interface BlobUploadRegistry {
  baseUrl: string;
  container: boolean;
  file: File;
  preSignedUrl?: string;
}
